import { Link } from 'react-router-dom'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const getFullYear = () => {
    return new Date().getFullYear();
}

const Footer = (props) => {
   
    return (
        <footer className={"" +props.hclass}>
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-5 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title" style={{
                                    overflow: 'hidden',
                                    maxWidth: '220px'
                                }}>
                                    <img
                                        src="/eugene-pereira-logo.avif"
                                        alt="Dr. Eugene G. Pereira, MD"
                                        style={{
                                            width: '280px',
                                            height: 'auto',
                                            filter: 'brightness(0) invert(1)',
                                            transform: 'scale(1.3)',
                                            transformOrigin: 'center center'
                                        }}
                                    />
                                </div>
                                <p style={{
                                    marginBottom: '18px',
                                    lineHeight: '1.7',
                                    fontSize: '15px',
                                    color: 'rgba(255, 255, 255, 0.8)'
                                }}>
                                    Leading interventional pain management specialist with over 20 years of
                                    experience, pioneering regenerative medicine solutions for chronic pain relief
                                    and helping patients reclaim their quality of life.
                                </p>
                                <div style={{
                                    padding: '14px',
                                    background: 'rgba(11, 159, 254, 0.15)',
                                    borderLeft: '3px solid #0B9FFE',
                                    marginBottom: '20px',
                                    borderRadius: '0 5px 5px 0'
                                }}>
                                    <p style={{
                                        fontSize: '15px',
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        margin: 0,
                                        fontWeight: '500',
                                        lineHeight: '1.6'
                                    }}>
                                        <strong style={{color: '#fff'}}>Board Certifications:</strong><br/>
                                        ABAPM • FIPP • ABIPP • ABAHPM
                                    </p>
                                </div>
                                <div className="social-widget">
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-facebook-app-symbol"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-linkedin"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="#"><i className="flaticon-instagram"></i></Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3 style={{fontSize: '22px', marginBottom: '20px', fontWeight: '600', color: '#fff'}}>Quick Links</h3>
                                </div>
                                <ul style={{listStyle: 'none', padding: 0, marginBottom: '30px'}}>
                                    <li style={{marginBottom: '14px'}}>
                                        <Link
                                            onClick={ClickHandler}
                                            to="/"
                                            className="footer-link"
                                            style={{
                                                fontSize: '15px',
                                                color: 'rgba(255, 255, 255, 0.8)',
                                                transition: 'all 0.3s ease',
                                                display: 'inline-block'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            → Home
                                        </Link>
                                    </li>
                                    <li style={{marginBottom: '14px'}}>
                                        <Link
                                            onClick={ClickHandler}
                                            to="/about"
                                            className="footer-link"
                                            style={{
                                                fontSize: '15px',
                                                color: 'rgba(255, 255, 255, 0.8)',
                                                transition: 'all 0.3s ease',
                                                display: 'inline-block'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            → About Dr. Pereira
                                        </Link>
                                    </li>
                                    <li style={{marginBottom: '14px'}}>
                                        <Link
                                            onClick={ClickHandler}
                                            to="/blog"
                                            className="footer-link"
                                            style={{
                                                fontSize: '15px',
                                                color: 'rgba(255, 255, 255, 0.8)',
                                                transition: 'all 0.3s ease',
                                                display: 'inline-block',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            → Medical Insights
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            onClick={ClickHandler}
                                            to="/contact"
                                            className="footer-link"
                                            style={{
                                                fontSize: '15px',
                                                color: 'rgba(255, 255, 255, 0.8)',
                                                transition: 'all 0.3s ease',
                                                display: 'inline-block'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            → Schedule Consultation
                                        </Link>
                                    </li>
                                </ul>

                                <div className="widget-title">
                                    <h3 style={{fontSize: '22px', marginBottom: '20px', fontWeight: '600', color: '#fff'}}>Contact Information</h3>
                                </div>
                                <ul style={{listStyle: 'none', padding: 0}}>
                                    <li style={{marginBottom: '16px'}}>
                                        <div>
                                            <div style={{fontSize: '13px', fontWeight: '600', marginBottom: '5px', color: '#fff'}}>
                                                Email
                                            </div>
                                            <span style={{fontSize: '12px', color: 'rgba(255, 255, 255, 0.8)'}}>
                                                <a
                                                    href='mailto:info@dreugenepereira.com'
                                                    style={{
                                                        color: 'rgba(255, 255, 255, 0.8)',
                                                        textDecoration: 'none',
                                                        whiteSpace: 'nowrap',
                                                        display: 'inline-block',
                                                        textTransform: 'none',
                                                        fontSize: '15px',
                                                    }}
                                                    onMouseEnter={(e) => e.target.style.color = '#0B9FFE'}
                                                    onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                                                >
                                                    info@dreugenepereira.com
                                                </a>
                                            </span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3 style={{fontSize: '22px', marginBottom: '20px', fontWeight: '600', color: '#fff'}}>Legal</h3>
                                </div>
                                <ul style={{listStyle: 'none', padding: 0}}>
                                    <li style={{marginBottom: '14px'}}>
                                        <Link
                                            onClick={ClickHandler}
                                            to="/privacy"
                                            className="footer-link"
                                            style={{
                                                fontSize: '15px',
                                                color: 'rgba(255, 255, 255, 0.8)',
                                                transition: 'all 0.3s ease',
                                                display: 'inline-block'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            → Privacy Policy
                                        </Link>
                                    </li>
                                    <li style={{marginBottom: '14px'}}>
                                        <Link
                                            onClick={ClickHandler}
                                            to="/terms"
                                            className="footer-link"
                                            style={{
                                                fontSize: '15px',
                                                color: 'rgba(255, 255, 255, 0.8)',
                                                transition: 'all 0.3s ease',
                                                display: 'inline-block'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            → Terms & Conditions
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            onClick={ClickHandler}
                                            to="/about"
                                            className="footer-link"
                                            style={{
                                                fontSize: '15px',
                                                color: 'rgba(255, 255, 255, 0.8)',
                                                transition: 'all 0.3s ease',
                                                display: 'inline-block'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.color = '#fff';
                                                e.target.style.transform = 'translateX(4px)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                                                e.target.style.transform = 'translateX(0)';
                                            }}
                                        >
                                            → About Us
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row g-0">
                        <div className="col col-lg-12 col-12 text-center">
                            <p className="copyright"> Copyright &copy; {getFullYear()} Dr. Eugene Pereira.</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;







